"use client";

import { Sheet, SheetContent } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";
import { cn } from "@/lib/utils";

export function BaseSidebarFrame({
  open,
  onToggle,
  children,
  width = 395,
}: {
  open: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  width?: number;
}) {
  return (
    <>
      {/* Toggle Button */}
      <div
        className={cn(
          "fixed top-1/2 -translate-y-1/2 z-30 transition-transform duration-300 left-0"
        )}
        style={{
          transform: open
            ? `translateX(${width}px)`
            : "translateX(0)",
        }}
      >
        <Button
          onClick={onToggle}
          className={cn(
            "bg-white hover:bg-white border text-gray-500 shadow-sm",
            "w-[28px] h-[72px] rounded-e-[16px]",
            "flex items-center justify-center"
          )}
          prefix={<ChevronLeft
            className={cn(
              "transition-transform text-gray-500",
              !open && "rotate-180"
            )}
          />}
        >
        </Button>
      </div>

      {/* Sidebar */}
      <div
        className={cn(
          "fixed top-[var(--header-height)] h-[calc(100vh-var(--header-height))]",
          "z-40 transition-all duration-300"
        )}
        style={{
          width,
          left: open ? 0 : -width,
        }}
      >
        <Sheet open={open} modal={false} onOpenChange={onToggle}>
          <SheetContent
            side="left"
            hiddenClose
            overlayVisible={false}
            onInteractOutside={(e) => e.preventDefault()}
            className={cn(
              `!w-[${width}px] p-0 shadow-lg flex border-0 flex-col`,
              "mt-[var(--header-height)] h-[calc(100vh-var(--header-height))]"
            )}
          >
            {children}
          </SheetContent>
        </Sheet>
      </div>
    </>
  );
}
